import {EditorState, StateEffect, StateField} from '@codemirror/state'
import type {EditorView} from '@codemirror/view'

const invalidateVideoUrlEffect = StateEffect.define<string>()

const invalidValidUrlsField = StateField.define<ReadonlySet<string>>({
  create: () => new Set(),
  update(invalidUrls, tr) {
    let result = invalidUrls
    for (const effect of tr.effects) {
      if (effect.is(invalidateVideoUrlEffect)) {
        result = new Set([...invalidUrls, effect.value])
      }
    }
    return result
  },
})

export function isKnownInvalidVideoUrl(state: EditorState, url: string) {
  return state.field(invalidValidUrlsField).has(url)
}

export function registerInvalidVideoUrl(view: EditorView, url: string) {
  view.dispatch({
    effects: [invalidateVideoUrlEffect.of(url)],
  })
}

/** Simple state field extension to keep track of known invalid video URLs for which we shouldn't render a <video> element. */
export const videoUrlsExtension = [invalidValidUrlsField]
